import { basicSlider } from './sliders';
import { linksCustomization, scrollTo, smoothScrolling } from './misc'; 
import setScrollBarWidth from 'set-scrollbar-width';  // Use with the Tailwind Container Break Out extension.

/* Flexible Content */
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger);

 

function usingJS(){
	document.querySelector('html').classList.remove('no-js')
	document.querySelector('html').classList.add('js')
}



/* *********************** */
/* Start all the functions */
/* *********************** */
window.onload = function() {
	// Init
	usingJS()
	setScrollBarWidth()
	linksCustomization()
	scrollTo()
	smoothScrolling()

	 

	// Sliders
	basicSlider()

	

}



jQuery(document).ready(function ($) {
	
	menu: {
		document.getElementById('burgermenu').addEventListener('click', function() {
			this.classList.toggle('actv');
			
			document.querySelector('.top-nav__logo').classList.toggle('actv');
			document.querySelector('.menu-menu-1-container').classList.toggle('actv');
		});
		document.querySelectorAll('.menu-menu-1-container a').forEach(function(item) {
			item.addEventListener('click', function() {
				document.getElementById('burgermenu').classList.remove('actv');
				document.querySelector('.top-nav__logo').classList.toggle('actv');
				document.querySelector('.menu-menu-1-container').classList.toggle('actv');
			});
		});
		
		
	}
	seemore : {
		document.querySelectorAll('[data-target="see_more_link"]').forEach(function(item) {
			item.addEventListener('click', function() {
				const seeMoreContent = item.parentElement.querySelector('[data-target="see_more"]');
				if (seeMoreContent.style.height === '100%') {
					// Get current height before animating to 0
					const currentHeight = seeMoreContent.offsetHeight;
					seeMoreContent.style.height = currentHeight + 'px';
					
					// Force browser reflow
					seeMoreContent.offsetHeight;
					
					gsap.to(seeMoreContent, {
						height: "0",
						duration: 0.3,
						ease: "power2.inOut",
						onComplete: () => {
							item.innerHTML = 'See more <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none"><path d="M16.293 8.79297L12 13.086L7.70697 8.79297L6.29297 10.207L12 15.914L17.707 10.207L16.293 8.79297Z" fill="#FFF5E9"/></svg>';
							item.querySelector('svg').classList.remove('rotate-180');
						}
					});
				} else {
					// First set height to 0
					seeMoreContent.style.height = '0';
					
					// Get the natural height
					seeMoreContent.style.position = 'absolute';
					seeMoreContent.style.visibility = 'hidden';
					seeMoreContent.style.height = 'auto';
					const height = seeMoreContent.offsetHeight;
					seeMoreContent.style.position = '';
					seeMoreContent.style.visibility = '';
					seeMoreContent.style.height = '0';
					
					// Animate to the natural height
					gsap.to(seeMoreContent, {
						height: height,
						duration: 0.3,
						ease: "power2.inOut",
						onComplete: () => {
							item.innerHTML = 'See less <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none"><path d="M16.293 8.79297L12 13.086L7.70697 8.79297L6.29297 10.207L12 15.914L17.707 10.207L16.293 8.79297Z" fill="#FFF5E9"/></svg>';
							item.querySelector('svg').classList.add('rotate-180');
							seeMoreContent.style.height = '100%';
						}
					});
				}
			});
		});
	}
	
	video_popup : {

		if ($('[data-function="video_modal"]').length) {

			$( '[data-function="video_modal"]' ).on('click', function(e){
				e.preventDefault();
				document.getElementById('modal_video_iframe').src = 'https://player.vimeo.com/video/' + $(this).data('content') + '?h=b560a760e4&autoplay=1&loop=1&byline=0&title=0';
				$('#modal_video').removeClass('invisible opacity-0');
				gsap.from('#modal_video_box', {scale:.8, autoAlpha:0, duration:.5, delay:.2});
				smoother.paused(true);
			});

			$( '#close_modal_video' ).on('click', function(e){
				e.preventDefault();
				$('#modal_video').addClass('invisible opacity-0');
				document.getElementById('modal_video_iframe').src = "";
				smoother.paused(false);
			});
			
		}

	}
	const tl = gsap.timeline({delay:.3});
tl.to('[data-name="intro_home"', {
	autoAlpha:1,
	duration:.7
})
.from('[data-name="list_needs"] div', 
	{
		autoAlpha:0,
		y:"+=20",
		duration:.5,
		stagger:.1

	}

) 
.from('[data-name="home_introt_txt"]',
	{
		autoAlpha:0,
		y:"+=20",
		duration:.5
	}, "-=1"
) 
.from('[data-name="intro_quote"]', {
	autoAlpha:0,
	duration:1.2
}, "-=.8")


gsap.to('#scrolldown', {
	y:"+=10px",
	yoyo:true,
	repeat: -1,
	duration:2, 
	ease: "power1.inOut", 
})
 
gsap.from('[data-name="stagger_items"] img', {
	autoAlpha:0,
	y:10,
	duration:.6,
	stagger:.1, 
	scrollTrigger:{
		trigger:'[data-name="stagger_items"]',
		start:'top 75%',

	}
})

gsap.utils.toArray('[data-target="txt_fadein"]').forEach(function(txt) {
	gsap.from(txt, {
	  autoAlpha: 0,
	  duration: 1.2,
	  scrollTrigger: {
		trigger: txt,
		start: 'top 90%'
	  }
	});
  });
  

gsap.utils.toArray('[data-name="list_need_box"]').forEach(function(box) {
	gsap.from(box, {
	  autoAlpha: 0,
	  duration: 0.6,
	  scrollTrigger: {
		trigger: box,
		start: 'top 75%',
		scrub: true
	  }
	});
  });



  const navLinks = document.querySelectorAll('.top-nav ul a[href^="#"]');
  navLinks.forEach((link) => {
    const targetSection = document.querySelector(link.getAttribute("href"));

    ScrollTrigger.create({
      trigger: targetSection,
      start: "top 20%", // When the top of the section hits 60% of the viewport height
      onEnter: () => {
        navLinks.forEach((el) => el.classList.remove("actv"));
        link.classList.add("actv");
      },
	  onEnterBack: () => {
        navLinks.forEach((el) => el.classList.remove("actv"));
        link.classList.add("actv");
      },
      onLeaveBack: () => {
        navLinks.forEach((el) => el.classList.remove("actv"));
      },
	  onLeave: () => {
        navLinks.forEach((el) => el.classList.remove("actv"));
      }
    });
  });



 
});


